import { Root as CheckboxRoot, CheckboxIndicator } from '@radix-ui/react-checkbox'
import { FormErrorMessage } from '$components'
import { cn } from '$components'
import { CheckIcon } from '$components'
import { useController } from 'react-hook-form'

export enum ServiceColour {
  Gray = '#94a3b8',
  Orange = '#ea580c',
  Red = '#dc2626',
  Green = '#16a34a',
  DarkBlue = '#1e3a8a',
  Purple = '#9333ea',
  Teal = '#14b8a6',
  Amber = '#f59e0b',
  Blue = '#3b82f6',
  Emerald = '#10b981',
  Pink = '#f43f5e',
}

export type ColourPickerProps = {
  name: string,
  error?: string
}

export function ColourInput({ name, error }: ColourPickerProps) {
  const { field } = useController({ name })

  const handleChange = (colour: string) => {
    if (field.value === colour) {
      field.onChange(null)
    } else {
      field.onChange(colour)
    }
  }

  return (
    <div className="flex flex-col w-full gap-1.5">
      <div className="flex flex-wrap gap-2">
        {Object.values(ServiceColour).map((colour) => (
          <div
            key={colour}
            className={cn('p-1 border border-transparent rounded-xl',{
              'border-gray-300': field.value === colour,
            })}
          >
            <CheckboxRoot
              checked={field.value === colour}
              onCheckedChange={() => handleChange(colour)}
              style={{ backgroundColor: colour }}
              className="size-7 rounded-[9px] flex items-center justify-center"
            >
              <CheckboxIndicator>
                <CheckIcon className="size-4 text-white" />
              </CheckboxIndicator>
            </CheckboxRoot>
          </div>
        ))}
      </div>

      <FormErrorMessage error={error} />
    </div>
  )
}
